export enum AssociationCategorie {
  Categorie1 = 'categorie1',
  Categorie2 = 'categorie2',
  Categorie3 = 'categorie3',
  TousCategories = '',
}
